module.exports = __webpack_public_path__ + "assets/img/144e-me.svg";